/* KIS productrail (sections/kis-product-rail.liquid): pijlknoppen op desktop scrollen de track één kaart (+ gap) verder;
   knoppen verschijnen alleen als de track echt scrolt (.kis-rail--scrollable) en verdwijnen aan het begin/einde.
   Hersteld 20 okt (ronde 10): het bestand was op 15 okt per ongeluk als 'dood' verwijderd terwijl de sectie het laadt. */
(function () {
  if (customElements.get('kis-rail')) return;
  class KisRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rail-track]');
      this.prev = this.querySelector('[data-rail-prev]');
      this.next = this.querySelector('[data-rail-next]');
      if (!this.track) return;
      this.onScroll = () => { if (this.raf) return; this.raf = requestAnimationFrame(() => { this.raf = 0; this.update(); }); };
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
      if (this.next) this.next.addEventListener('click', () => this.step(1));
      if ('ResizeObserver' in window) { this.ro = new ResizeObserver(() => this.update()); this.ro.observe(this.track); }
      else window.addEventListener('resize', this.onScroll);
      this.update();
    }
    disconnectedCallback() { if (this.ro) this.ro.disconnect(); window.removeEventListener('resize', this.onScroll); }
    stepSize() {
      const item = this.track.querySelector('[data-rail-item]');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return item ? item.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
    }
    step(dir) {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: dir * this.stepSize(), behavior: reduce ? 'auto' : 'smooth' });
    }
    update() {
      const t = this.track; const max = t.scrollWidth - t.clientWidth;
      this.classList.toggle('kis-rail--scrollable', max > 2);
      if (this.prev) this.prev.hidden = t.scrollLeft <= 2;
      if (this.next) this.next.hidden = t.scrollLeft >= max - 2;
    }
  }
  customElements.define('kis-rail', KisRail);
})();
